import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";

const PlantillaModal = ({ mostrar, onClose, titulo, children, zIndex = 50, maxWidth = 'max-w-5xl' }) => {
  // Cerrar modal con tecla Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && mostrar) {
        onClose();
      }
    };

    if (mostrar) {
      document.addEventListener('keydown', handleKeyDown);
      // Prevenir scroll del body cuando el modal está abierto
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [mostrar, onClose]);

  if (!mostrar) return null;

  // Función para manejar el clic fuera del modal
  const handleClicFuera = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4"
      style={{ zIndex }}
      onClick={handleClicFuera}
    >
      <div className={`bg-white rounded-xl w-full ${maxWidth} max-h-[85vh] p-6 shadow-lg relative flex flex-col`}>
        {/* Cierre */}
        <button
          onClick={onClose}
          className="absolute top-4 right-6 text-gray-400 hover:text-white hover:bg-red-500 rounded-full p-2 transition-all duration-200 z-10"
          aria-label="Cerrar modal"
        >
          <FaTimes className="w-5 h-5" />
        </button>

        {/* Título */}
        {titulo && <h2 className="text-sm font-sans text-center font-semibold mb-4 flex-shrink-0">{titulo}</h2>}

        {/* Contenido del modal con scroll */}
        <div className="overflow-y-auto flex-1 scrollbar-hide">{children}</div>
      </div>
    </div>
  );
};

export default PlantillaModal;
